<template>
  <section>
    <!-- 日期选择区域 -->
    <el-form class="form_cls" :model="filters" @submit.native.prevent inline>
      <el-form-item label="手术日期">
        <!-- PC端日期选择器 -->
        <el-date-picker
          v-if="!isMobile"
          v-model="selectedDate"
          type="date"
          placeholder="选择日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="datePickerOptions"
          :clearable="false"
          :editable="false" 
          @change="onDateChange"
          size="small"
          class="compact-date-picker"
        ></el-date-picker>
        
        <!-- 移动端 Vant 日期选择器 -->
        <div v-else class="mobile-date-wrapper" @click="showDatePicker = true">
          <span class="date-text">{{ selectedDate }}</span>
          <i class="el-icon-arrow-down"></i>
        </div>

        <!-- Vant 弹窗日期选择 -->
        <van-popup v-model="showDatePicker" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="选择手术日期"
            :min-date="minDateObj"
            :max-date="maxDateObj"
            @confirm="onConfirmDate"
            @cancel="showDatePicker = false"
          />
        </van-popup>
      </el-form-item>
      
      <!-- 操作按钮 -->
      <el-form-item
        v-if="!item.IsHide && (isMobile && item.name == '导出' ? false : true)"
        v-for="item in buttonList"
        v-bind:key="item.id"
      >
        <el-button
          :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 本周范围提示 -->
    <div style="margin-bottom: 10px; padding: 8px 12px; background: #f5f7fa; border-radius: 4px; color: #606266; font-size: 13px;">
      <i class="el-icon-info" style="margin-right: 5px; color: #909399;"></i>
      填报规则: 当日填报当日手术数据。
      <br/>*允许修改手术日期为{{ weekRangeText }}的填报数据
    </div>

    <!-- 列表 -->
    <div class="table_top_div">
      <el-table
        :data="tabel_list"
        border
        :cell-style="cellStyle"
        cell-class-name="cell_class_name"
        header-cell-class-name="header_cell_name"
        highlight-current-row
        v-loading="listLoading"
        :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: '7px 0' }"
        style="width: 100%"
      >
        <el-table-column prop="name" label="医院名称" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center; gap: 6px;">
              <i class="el-icon-office-building" style="color: #909399; font-size: 14px; flex-shrink: 0;"></i>
              <span style="font-size: 13px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mtdNumber" label="MTD" width="70" align="center">
          <template slot-scope="scope">
            <span style="font-size: 13px;">{{ scope.row.mtdNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="number" label="上报" width="100" align="center">
          <template slot-scope="scope">
            <el-input
              type="text"
              v-model="scope.row.number"
              placeholder="填写"
              size="small"
              @input="scope.row.number = scope.row.number.replace(/[^\d]/g, '')"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 底部操作 -->
      <div style="margin-top: 15px;">
        <el-button 
          type="primary" 
          v-preventReClick="3000" 
          @click="save" 
          icon="el-icon-upload2"
          style="width: 100%;"
        >
          确认上报
        </el-button>
        <div style="margin-top: 10px; padding: 10px; background: #fffbf0; border: 1px solid #ffe8b3; border-left: 3px solid #faad14; border-radius: 4px; font-size: 12px; color: #8c8c8c; line-height: 1.6;">
          <i class="el-icon-warning-outline" style="color: #faad14; margin-right: 5px;"></i>
          注：本耗用量预测系基于销售人员的手术跟台观察、经销商的库存耗用等合规信息来源对产品耗用的预测估计。
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { flacs_saveDailyData, flacs_getDailyDataByDate } from '../../api/api'
import { getButtonList } from '../../promissionRouter'

export default {
  data() {
    return {
      selectedDate: this.getToday(),  // 选定的手术日期（默认今天）
      showDatePicker: false,          // 控制移动端日期弹窗
      currentDate: this.getTodayDate(),  // Vant日期选择器绑定的Date对象（今天）
      weekStart: null,  // 本周开始日期
      weekEnd: null,  // 本周结束日期（今天）
      isMobile: false,
      buttonList: [],
      token: '',
      tabel_list: [],
      listLoading: false,
      filters: {  // 添加缺失的filters对象
        day: ''
      }
    }
  },
  computed: {
    weekRangeText() {
      if (!this.weekStart || !this.weekEnd) return ''
      return `${this.formatDate(this.weekStart)} ~ ${this.formatDate(this.weekEnd)}`
    },
    // 移动端原生 input 的最小日期（本周一）
    minDate() {
      return this.weekStart ? this.formatDate(this.weekStart) : ''
    },
    // 移动端原生 input 的最大日期（今天）
    maxDate() {
      return this.formatDate(new Date())
    },
    // Vant日期选择器需要的 Date 对象限制
    minDateObj() {
      return this.weekStart ? this.weekStart : new Date(2020, 0, 1)
    },
    maxDateObj() {
      return this.getTodayDate()
    },
    datePickerOptions() {
      const self = this
      return {
        disabledDate(time) {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          
          // 不能选明天及以后的日期
          if (time.getTime() > today.getTime()) return true
          
          // 不能选本周之前的日期
          if (self.weekStart && time.getTime() < self.weekStart.getTime()) return true
          
          return false
        }
      }
    }
  },
  methods: {
    getToday() {
      return this.formatDate(new Date())
    },
    
    getTodayDate() {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return today
    },
    
    formatDate(date) {
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    
    calculateWeekRange() {
      const today = this.getTodayDate()
      const dayOfWeek = today.getDay()

      if (dayOfWeek === 1) {
        this.weekStart = new Date(today)
        this.weekStart.setDate(today.getDate() - 1)
      } else if (dayOfWeek === 0) {
        this.weekStart = new Date(today)
        this.weekStart.setDate(today.getDate() - 6)
      } else {
        const offset = -(dayOfWeek - 1)
        this.weekStart = new Date(today)
        this.weekStart.setDate(today.getDate() + offset)
      }

      this.weekStart.setHours(0, 0, 0, 0)
      this.weekEnd = new Date(today)
      this.weekEnd.setHours(0, 0, 0, 0)
    },
    
    async onDateChange(val) {
      if (!val) return
      // 同步更新 Vant 绑定的 currentDate
      this.currentDate = new Date(val)
      await this.getModules()
    },
    
    // 移动端 Vant 确认日期
    async onConfirmDate(value) {
      this.showDatePicker = false
      this.selectedDate = this.formatDate(value)
      await this.getModules()
    },
    
    cellStyle({ column }) {
      // 不设置背景色，使用默认
      return {}
    },
    checkNaN(value, cb) {
      const val = parseFloat(value)
      return isNaN(val) ? undefined : cb(val)
    },
    back_url() {
      //   this.$router.replace({ path: this.$route.query.back_url })
      this.$router.go(-1)
    },
    async save() {
      // 🔥 处理数据：确保 number 为空时默认为 0，并过滤掉无效数据
      const submitData = this.tabel_list
        .filter(item => item && (item.flacsHcoId || item.FlacsHcoId))  // 过滤掉无效数据
        .map(item => ({
          FlacsHcoId: item.flacsHcoId || item.FlacsHcoId,  // 后端使用大驼峰命名
          ZcnCode: item.zcnCode || item.ZcnCode,
          Name: item.name || item.Name,
          Number: item.number != null && item.number !== '' ? (Number(item.number) || 0) : 0,  // 如果为空，默认为 0
          MTDNumber: item.mtdNumber || item.MTDNumber || 0
        }))
      
      if (submitData.length === 0) {
        this.$message.error('没有有效的数据可以提交')
        return
      }

      // 传递 selectedDate 和 data
      const params = {
        selectedDate: this.selectedDate,
        data: submitData
      }
      
      const { data } = await flacs_saveDailyData(params)
      if (data.code == 200) {
        this.$message.success(data.msg || '上报成功！')
        // 刷新页面数据，让用户确认提交成功
        await this.getModules()
      } else {
        this.$message.error(data.msg)
      }
    },
    async ExportAccount() {
      this.dialogVisible_upload = true
    },
    open_approve(res) {
      this.request_list = res
      this.dialogVisible_approve = true
      console.log(this.request_list)
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getModules()
    },
    getModules_search() {
      this.pageNumber = 1
      this.getModules()
      //   this.getModules2()
    },
    //获取用户列表 - 按日期查询
    getModules() {
      this.listLoading = true
      flacs_getDailyDataByDate({ selectedDate: this.selectedDate }).then((res) => {
        this.tabel_list = res.data
        this.listLoading = false
      }).catch(() => {
        this.$message.error('加载数据失败')
        this.listLoading = false
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
  },
  mounted() {
    this.calculateWeekRange()  // 计算本周范围
    this.getModules_search()
    if (window.innerWidth <= 767) {
      this.isMobile = true
      this.collapsedClass = 'menu-collapsed'
      //   this.SidebarVisible = false
    }
    var time = new Date()
    var year = time.getFullYear()
    var month = time.getMonth() + 1
    var day = time.getDate()
    // this.todays =
    var todays = year + '-' + (Number(month) < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
    this.filters.day = todays
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style scoped>
/* 日期选择器紧凑样式 */
.compact-date-picker {
  width: 130px !important;
}

/* 移动端日期选择器 */
.mobile-date-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  transition: all 0.3s;
  width: 130px;
}

.mobile-date-wrapper:active {
  background-color: #f5f7fa;
}

.date-text {
  font-size: 13px;
  color: #606266;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-date-wrapper i {
  color: #909399;
  font-size: 12px;
  flex-shrink: 0;
}

/* 表格样式 */
.cell_class_name {
  text-align: center !important;
}

/* 输入框居中 */
.table_top_div >>> .el-input__inner {
  text-align: center;
}

/* 隐藏 number 输入框的上下箭头 */
.table_top_div >>> input[type="number"]::-webkit-inner-spin-button,
.table_top_div >>> input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.table_top_div >>> input[type="number"] {
  -moz-appearance: textfield;
}

/* 移动端适配 */
@media (max-width: 767px) {
  .compact-date-picker,
  .mobile-date-wrapper {
    width: 130px !important;
  }
}
</style>
